import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './NatureNaniApp';
import { initSentry } from '@/utils/sentry';

initSentry(); // Must be called before ReactDOM.createRoot

const root = createRoot(document.getElementById('root')!);
root.render(<App />);
